import {
    GET_PRODUCT_BACKGROUNDS,
    GET_PRODUCT_OVERLAYS
} from 'app/actions/types';
import produce from 'immer';

const initialState = {
    backgrounds: [],
    overlays: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PRODUCT_BACKGROUNDS:
            return produce(state, draft => {
                draft.backgrounds = action.payload;
            });

        case GET_PRODUCT_OVERLAYS:
            return produce(state, draft => {
                draft.overlays = action.payload;
            });

        default:
            return state;
    }
}